var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListDeleteOnHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E64B38",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delete-Icon-Reversed-Copy",
    transform: "translate(10.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73875,2.113125 L7.258125,2.113125 L7.258125,1.378125 C7.258125,1.010625 6.9825,0.735 6.615,0.735 L4.41,0.735 C4.0425,0.735 3.766875,1.010625 3.766875,1.378125 L3.766875,2.113125 L1.1025,2.113125 C0.91875,2.113125 0.735,2.296875 0.735,2.480625 C0.735,2.664375 0.91875,2.848125 1.1025,2.848125 L9.73875,2.848125 C9.9225,2.848125 10.10625,2.664375 10.10625,2.480625 C10.10625,2.296875 9.9225,2.113125 9.73875,2.113125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.010625,4.59375 L2.205,13.41375 C2.205,13.689375 2.480625,13.78125 2.664375,13.78125 L8.085,13.78125 C8.360625,13.78125 8.544375,13.5975 8.544375,13.41375 L9.73875,4.59375 C9.73875,4.318125 9.555,4.0425 9.279375,4.0425 L1.47,4.0425 C1.194375,4.0425 1.010625,4.318125 1.010625,4.59375 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDeleteOnHover);
export default __webpack_public_path__ + "static/media/ListDeleteOnHover.fe920806ca825cb64c897accc7e1c9b3.svg";
export { ForwardRef as ReactComponent };